<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <template v-slot:activator="{ on }">
      <v-btn
        fab
        x-small
        color="white"
        class="color-a"
        dark
        v-on="on"
        style="margin: 0 10px;"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="color-a"
        >Lägg till ny punkt i dagordningen</v-card-title
      >
      <v-card-text>
        <agenda-form ref="form" @file-selected="onFileSelected"></agenda-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="create"
          >Lägg till</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AgendaForm from "@/components/agenda/AgendaForm.vue";

export default {
  props: {
    meetingId: String
  },
  components: { AgendaForm },
  data() {
    return {
      dialog: false,
      selectedFile: null
    };
  },
  methods: {
    onFileSelected(file) {
      this.selectedFile = file;
    },
    close() {
      this.$refs.form.close();
      this.dialog = false;
      this.selectedFile = null;
    },
    async create() {
      const agendaData = {
        meetingId: this.meetingId,
        ...this.$refs.form.form
      };

      const success = await this.$store.dispatch(
        "meetings/createAgendaItem",
        agendaData
      );

      if (success && this.selectedFile) {
        // Find the newly created item by matching id and text
        const meeting = this.$store.getters["meetings/getMeeting"](
          this.meetingId
        );
        const newItem = meeting.agenda.find(
          item => item.id === agendaData.id && item.text === agendaData.text
        );

        if (newItem) {
          const result = await this.$store.dispatch(
            "meetings/uploadAgendaAttachment",
            {
              meetingId: this.meetingId,
              agendaUid: newItem.uid,
              file: this.selectedFile
            }
          );

          if (result) {
            const newAgendaArray = meeting.agenda.map(itm => {
              if (itm.uid === newItem.uid) {
                return {
                  ...itm,
                  attachment: result.url,
                  attachmentFileName: result.fileName
                };
              }
              return itm;
            });

            await this.$store.dispatch("meetings/editAgendaItem", {
              meetingId: this.meetingId,
              newAgendaArray
            });
          }
        }
      }

      if (success) {
        this.close();
      }
    }
  }
};
</script>

<style></style>
